/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit DropdownFilter.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import InputSmall from 'DesignSystem/InputSmall/view.js'
import React from 'react'



export default function DropdownFilter({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  backgroundColor= "#ffffff",
disabled,
isInvalid,
height= "auto",
maxWidth= 200,
minWidth= 200,
onBlur,
onChangeFilter,
onClickShow,
onCopy,
onKeyDown,
onPaste,
value,
valueWidth= 510,
paddingBottom,
paddingLeft,
paddingRight,
paddingTop,
fontSize,
borderBottomLeftRadius= 5,
borderBottomRightRadius= 5,
borderTopLeftRadius= 5,
borderTopRightRadius= 5,
isMultiChoice
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<InputSmall
 data-testid="DropdownFilter.InputSmall"
 data-view-path={dataViewPath}
 autoComplete="off"
 backgroundColor={backgroundColor}
 color="#161616"
 disabled={disabled}
 isInvalid={isInvalid}
 height={height}
 maxWidth={maxWidth}
 minWidth={minWidth}
 onBlur={onBlur}
 onChange={onChangeFilter}
 onFocus={onClickShow}
 onCopy={onCopy}
 onKeyDown={onKeyDown}
 onPaste={onPaste}
 placeholder="Filter"
 value={value}
 width={valueWidth}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={isMultiChoice ? "35px" : paddingRight}
 paddingTop={paddingTop}
 fontSize={fontSize}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
/>
{children}
</React.Fragment>)
}